export default {"src":"/_next/static/media/API.7788d732.svg","height":32,"width":32};